<template>
  <div class="ad-set-header-row">
    <div class="heading-groups row">
      <div class="col-xs-3 highlight today-date" :class="offsetClass">
        <div class="heading">Today</div>
        <div class="today-date__date">{{ startTime }} - Now</div>
      </div>
      <div class="col-xs-3 highlight date-range">
        <div class="heading">Selected Date Range</div>
        <div v-if="hasChartDates" class="date-range__display">
          <span class="date-range__start-date">{{ chartStartDate | formatDate }}</span>
          <span class="date-range__end-date" v-if="chartStartDate !== chartEndDate">- {{ chartEndDate | formatDate }}</span>
        </div>

        <div class="date-range__display--is-updating" v-else-if="chartIsUpdating">Chart Updating...</div>
        <div class="col-xs-1"></div>
      </div>
      <div class="col-xs-1 separator"></div>

    </div>
    <div class="row headings">
        <div class="col-xs-2" @click="$emit('sort', 'name')">
        <div>Name</div>
        <ad-set-sort-arrows sortKey="name" :sort-by="sortBy" :sort-direction="sortDirection"></ad-set-sort-arrows>
      </div>
      <div class="col-xs-1" @click="$emit('sort', 'is_active')">
        Off/On
        <ad-set-sort-arrows sortKey="is_active" :sort-by="sortBy" :sort-direction="sortDirection"></ad-set-sort-arrows>
      </div>
      <div v-if="showScheduleToggle" class="col-xs-1" @click="$emit('sort', 'ignore_schedule')">
        Schedule<br>
        Off/On
        <ad-set-sort-arrows sortKey="ignore_schedule" :sort-by="sortBy" :sort-direction="sortDirection"></ad-set-sort-arrows>
      </div>
        <div class="col-xs-1 separator"></div>
        <div class="col-xs-1" @click="$emit('sort', 'product_type')" v-if="showProductType"
           dusk="ad-set-list-product-type">
        Type
        <ad-set-sort-arrows sortKey="product_type" :sort-by="sortBy"
                            :sort-direction="sortDirection"></ad-set-sort-arrows>
      </div>
      <div class="col-xs-1 highlight" @click="$emit('sort', 'daily_count')">
        Events
        <ad-set-sort-arrows sortKey="daily_count" :sort-by="sortBy"
                            :sort-direction="sortDirection"></ad-set-sort-arrows>
      </div>
      <div class="col-xs-1 highlight" @click="$emit('sort', 'daily_spend')">
        Spend
        <ad-set-sort-arrows sortKey="daily_spend" :sort-by="sortBy"
                            :sort-direction="sortDirection"></ad-set-sort-arrows>
      </div>
      <div class="col-xs-1 highlight" @click="$emit('sort', 'todays_budget')">
        Budget
        <ad-set-sort-arrows sortKey="todays_budget" :sort-by="sortBy"
                            :sort-direction="sortDirection"></ad-set-sort-arrows>
      </div>
      <div class="col-xs-1 highlight" @click="$emit('sort', 'click_count')">
        Events
        <ad-set-sort-arrows sortKey="lead_count" :sort-by="sortBy" :sort-direction="sortDirection"></ad-set-sort-arrows>
      </div>
      <div class="col-xs-1 highlight" @click="$emit('sort', 'cost')">
        Spend
        <ad-set-sort-arrows sortKey="cost" :sort-by="sortBy" :sort-direction="sortDirection"></ad-set-sort-arrows>
      </div>
      <div class="col-xs-1 highlight" @click="$emit('sort', 'placement')">
        Position
        <ad-set-sort-arrows sortKey="placement" :sort-by="sortBy" :sort-direction="sortDirection"></ad-set-sort-arrows>
      </div>
    </div>
  </div>
</template>

<script>
  import { todaysStartTime } from 'js/utils';
  import AdSetSortArrows from './ad-set-sort-arrows';
  import moment from 'moment';
  import { mapGetters } from 'vuex';

  export default {
    name: 'ad-set-header-row',
    props: {
      sortBy: String,
      sortDirection: String,
      chartStartDate: String,
      chartEndDate: String,
      chartIsUpdating: Boolean,
      showProductType: Boolean
    },

    filters: {
      formatDate (date) {
        let dateToFormat = moment(date);
        if (!dateToFormat.isValid()) return '';

        let dateIsToday = dateToFormat.isSame(moment(), 'd');
        return dateIsToday ? 'Today' : dateToFormat.format('MM/DD/YYYY');
      }
    },

    computed: {
      ...mapGetters([
        'isCostPerClick',
        'isCostPerLead',
        'isBankrateSelect'
      ]),

      offsetClass () {
        let biddingOffset = 4;
        let productTypeOffset = this.showProductType ? 1 : 0;

        if (this.showScheduleToggle) {
          biddingOffset += 1;
        }

        return `col-xs-offset-${biddingOffset + productTypeOffset}`;
      },

      hasChartDates () {
        return this.chartStartDate && this.chartEndDate;
      },

      showScheduleToggle () {
        return this.featureFlag('ad-set-ignore-schedule') && this.isBankrateSelect;
      },

      startTime () {
        return todaysStartTime().format('MM/DD h:mmA');
      },
    },
    components: { AdSetSortArrows }
  }
</script>

<style lang="scss" scoped>
  .ad-set-header-row {
    border-bottom: 1px solid #4b4f57;
    color: #202020;
    font-size: 15px;
    font-weight: 600;
    user-select: none;
  }

  .ad-set-header-row > .row > div {
    padding-bottom: 15px;
    padding-top: 10px;
  }

  .headings > div {
    align-items: center;
    cursor: pointer;
    display: flex;
  }

  .heading-groups {
    color: rgba(6, 6, 6, 0.65);
    font-size: 14px;
    height: 65px;

    .heading {
      text-transform: uppercase;
    }

    > div {
      height: 100%;
    }
  }

  .highlight {
    background-color: #cecece;
  }

  .separator {
    background-color: white;
  }
</style>


